import React, { useEffect } from 'react';
import { captureGoogleAuthError, googleCalAuth } from '../../../data-access';
import { CircularProgress } from '@mui/material';

const GoogleAuthCallback: React.FC = () => {
  useEffect(() => {
    googleCalAuth
      .signinPopupCallback()
      .catch((error) => captureGoogleAuthError(error, 'sign_in', 'popup_callback'))
      .finally(() => window.close());
  }, []);

  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}
    >
      <CircularProgress />
    </div>
  );
};

export default GoogleAuthCallback;
